module.exports = __webpack_public_path__ + "fonts/HumanMay14.7b4e1345.woff";